export const printReferralUrl = (demandId: string) => `/api/demands/files/${demandId}/referral`;
export const printVerdictUrl = (demandId: string) => `/api/demands/files/${demandId}/verdict`;
